import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import FileUploadIcon from '@material-ui/icons/CloudUploadTwoTone';
import FilePicker from '../FilePicker';

const styles = () => ({
  image: {
    width: 100,
  },
});

const ImageUpload = ({ classes, photoUrl, onFilePicked }) => {
  let requestFilePickerOpen = null;
  return (
    <div>
      {!photoUrl ? null :
        <div>
          <img src={photoUrl} alt={photoUrl} className={classes.image} />
        </div>
      }
      {!photoUrl ? <Button size="small" color="primary" onClick={() => requestFilePickerOpen()}>
        <FileUploadIcon style={{marginRight: 10}} /> Wybierz plik ...
      </Button> : null}
      <FilePicker
        onFilePicked={onFilePicked}
        accept={'image/jpg,image/jpeg,image/png'}
        ref={picker => requestFilePickerOpen = picker && picker.onFilePickerOpenRequest.bind(picker)}
      />
    </div>
  );
};

ImageUpload.propTypes = {
  classes: PropTypes.object.isRequired,
  photoUrl: PropTypes.string,
  onFilePicked: PropTypes.func.isRequired,
};

export default withStyles(styles)(ImageUpload);


// WEBPACK FOOTER //
// ./src/components/common/ImageUpload.js